import type { CompanyEvents, CompanyEventsRequest } from "@/modules/companies/client/api/types"

import { getResultFromResponse } from "@/modules/apiRequests/handlers"
import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"
import { toCamelCaseKeys } from "@/modules/format/object/toCamelCaseKeys"
import { toSnakeCaseKeys } from "@/modules/format/object/toSnakeCaseKeys"

export const COMPANY_EVENTS_QUERY_KEY = "companies::company::events"
const COMPANY_EVENTS_ENDPOINT = "/jobteaser.company.events.v1alpha1/EventsService/CompanyEvents"

export const getCompanyEvents = async ({
  nextRequest,
  ...restParams
}: CompanyEventsRequest): Promise<CompanyEvents> => {
  return fetcher(COMPANY_EVENTS_ENDPOINT, {
    nextRequest,
    requestInit: {
      body: JSON.stringify(toSnakeCaseKeys(restParams)),
      method: "POST",
    },
    serviceDomain: "APIGW_IN_KRAKEND_API",
  })
    .then(getResultFromResponse<CompanyEvents>({ transformResult: toCamelCaseKeys<CompanyEvents> }))
    .catch(handleFetchError(COMPANY_EVENTS_ENDPOINT))
}
